"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsBillingProfiles = PaymentsBillingProfiles;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const styled_components_1 = __importStar(require("styled-components"));
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const react_intl_1 = require("react-intl");
const ProfileList = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
`;
const ProfileCard = styled_components_1.default.div `
	background: ${({ theme }) => theme.color.gray1};
	border: 1px solid ${({ theme }) => theme.color.gray4};
	border-radius: ${({ theme }) => theme.borderRadius.base};
	padding: 1.25rem 1.5rem;
	cursor: pointer;
	transition: border-color ${({ theme }) => theme.transition.basic},
		box-shadow ${({ theme }) => theme.transition.basic};

	&:hover {
		border-color: ${({ theme }) => theme.color.gray6};
	}

	${({ isActive, theme }) => isActive &&
    (0, styled_components_1.css) `
			border-color: ${theme.color.brand1};
			box-shadow: 0 0 0 1px ${theme.color.brand1};
			&:hover {
				border-color: ${theme.color.brand1};
			}
		`}
`;
const ProfileCardHeader = styled_components_1.default.div `
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.5rem;
	margin-bottom: 0.75rem;
`;
const ProfileCardDescription = styled_components_1.default.span `
	color: ${({ theme }) => theme.color.gray8};
	font-size: ${({ theme }) => theme.fontSizes.s};
`;
const ProfileCardBody = styled_components_1.default.div `
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
	align-items: center;
	justify-content: space-between;
`;
const ProfileCardInfo = styled_components_1.default.div `
	display: flex;
	align-items: center;
	gap: 0.75rem;
	flex: 1 1 auto;
	min-width: 0;
`;
const ProfileCardFields = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
`;
const ProfileCardName = styled_components_1.default.span `
	font-weight: 600;
`;
const ProfileCardAddress = styled_components_1.default.span `
	color: ${({ theme }) => theme.color.gray8};
	font-size: ${({ theme }) => theme.fontSizes.s};
`;
const ProfileCardActions = styled_components_1.default.div `
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;
function BillingProfileCard({ profile, isSelectedDefault, onSelectDefault, header, editTo, onDelete, canDelete, }) {
    const intl = (0, react_intl_1.useIntl)();
    const formattedAddress = [profile.street, profile.city, profile.postalCode].filter(Boolean).join(', ');
    return ((0, jsx_runtime_1.jsxs)(ProfileCard, { isActive: isSelectedDefault, onClick: onSelectDefault, role: "button", tabIndex: 0, children: [header && (0, jsx_runtime_1.jsx)(ProfileCardHeader, { children: header }), (0, jsx_runtime_1.jsxs)(ProfileCardBody, { children: [(0, jsx_runtime_1.jsxs)(ProfileCardInfo, { children: [(0, jsx_runtime_1.jsx)(antd_1.Radio, { checked: isSelectedDefault, onClick: event => {
                                    event.stopPropagation();
                                    onSelectDefault();
                                } }), (0, jsx_runtime_1.jsxs)(ProfileCardFields, { children: [(0, jsx_runtime_1.jsx)(ProfileCardName, { children: profile.name }), (0, jsx_runtime_1.jsx)(ProfileCardAddress, { children: formattedAddress })] })] }), (0, jsx_runtime_1.jsxs)(ProfileCardActions, { onClick: event => event.stopPropagation(), children: [(0, jsx_runtime_1.jsx)(elements_1.Link, { to: editTo, children: (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "small", type: "default", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.edit" }) }) }), canDelete && onDelete && ((0, jsx_runtime_1.jsx)(antd_1.Popconfirm, { title: intl.formatMessage({
                                    id: 'admin.payments.payment_methods.are_you_sure_remove_billing_profile',
                                }), okText: intl.formatMessage({ id: 'general.yes' }), cancelText: intl.formatMessage({ id: 'general.no' }), onConfirm: onDelete, children: (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "small", type: "default", danger: true, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.delete" }) }) }))] })] })] }));
}
function PaymentsBillingProfiles() {
    const intl = (0, react_intl_1.useIntl)();
    const [billingProfiles, setBillingProfiles] = react_1.default.useState([]);
    const [selectedDefaultProfile, setSelectedDefaultProfile] = react_1.default.useState(0);
    // The main billing profile is, by convention, the oldest one per company (lowest id) — the one
    // created together with the company during registration. It is synced with the company details.
    const sortedProfiles = [...billingProfiles].sort((a, b) => { var _a, _b; return ((_a = a.id) !== null && _a !== void 0 ? _a : 0) - ((_b = b.id) !== null && _b !== void 0 ? _b : 0); });
    const [mainProfile, ...otherProfiles] = sortedProfiles;
    const getAllCompanyBillingProfiles = async () => {
        try {
            const { allBillingProfilesById } = await Api.CompanyBillingProfile.getBillingProfiles();
            setBillingProfiles(allBillingProfilesById);
            const currentDefault = allBillingProfilesById.find(profile => profile.isDefault);
            if (currentDefault === null || currentDefault === void 0 ? void 0 : currentDefault.id) {
                setSelectedDefaultProfile(currentDefault.id);
            }
        }
        catch (err) {
            antd_1.notification.error({
                message: intl.formatMessage({ id: 'global.notification_variants.error' }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
            console.error(err);
        }
    };
    const setCompanyDefaultProfile = async (billingProfileId) => {
        try {
            await Api.CompanyBillingProfile.setDefaultBillingProfile(billingProfileId);
            antd_1.notification.success({
                message: intl.formatMessage({ id: 'admin.payments.billing_profile_changed_default' }),
                placement: 'bottomRight',
            });
        }
        catch (err) {
            antd_1.notification.error({
                message: intl.formatMessage({ id: 'global.notification_variants.error' }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
            console.error(err);
        }
    };
    const selectAsDefault = (billingProfileId) => {
        if (billingProfileId && billingProfileId !== selectedDefaultProfile) {
            setCompanyDefaultProfile(billingProfileId);
            setSelectedDefaultProfile(billingProfileId);
        }
    };
    const deleteBillingProfile = async (billingProfileId) => {
        try {
            await Api.CompanyBillingProfile.deleteBillingProfile(billingProfileId);
            getAllCompanyBillingProfiles();
            antd_1.notification.success({
                message: intl.formatMessage({ id: 'admin.payments.billing_profile_deleted' }),
                placement: 'bottomRight',
            });
        }
        catch (err) {
            antd_1.notification.error({
                message: intl.formatMessage({ id: 'general.error' }),
                description: intl.formatMessage({ id: 'general.something_went_wrong' }),
            });
            console.error(err);
        }
    };
    react_1.default.useEffect(() => {
        getAllCompanyBillingProfiles();
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(ProfileList, { children: [mainProfile && ((0, jsx_runtime_1.jsx)(BillingProfileCard, { profile: mainProfile, isSelectedDefault: mainProfile.id === selectedDefaultProfile, onSelectDefault: () => selectAsDefault(mainProfile.id), header: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(elements_1.Tag, { color: "blue", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.main_billing_profile.badge" }) }), (0, jsx_runtime_1.jsx)(ProfileCardDescription, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.main_billing_profile.description" }) })] }), editTo: "/admin/firemny-profil", canDelete: false })), otherProfiles.map(profile => {
                        var _a, _b;
                        const isSelectedDefault = profile.id === selectedDefaultProfile;
                        const canDelete = !isSelectedDefault && ((_b = (_a = profile.offers) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) === 0;
                        return ((0, jsx_runtime_1.jsx)(BillingProfileCard, { profile: profile, isSelectedDefault: isSelectedDefault, onSelectDefault: () => selectAsDefault(profile.id), editTo: `/admin/platby/fakturacny-profil/${profile.id}`, canDelete: canDelete, onDelete: () => deleteBillingProfile(profile.id) }, profile.id));
                    })] }), (0, jsx_runtime_1.jsx)("div", { className: "text-center", children: (0, jsx_runtime_1.jsx)(elements_1.Link, { to: "/admin/platby/fakturacny-profil", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "primary", size: "middle", className: "m-t-m m-b-s", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.create_new" }) }) }) })] }));
}
